
define('text!areas/kb/views/index.html',[],function () { return '<div class="knowledgebase-container">\r\n    <iframe data-bind="attr: {src: $data.knowledgeBaseUrl}"></iframe>\r\n</div>';});

